export const SiteFooter = () => (
  <footer className="jt-footer" data-testid="site-footer">
    <h2 className="jt-footer__copy">© {new Date().getFullYear()} All rights reserved.</h2>
    <div className="jt-footer__right">
      <h2 className="jt-footer__brand"><a href="/" data-testid="footer-home-link">joetanis.com</a></h2>
      <h2 className="jt-footer__tag">Jewelry, Architectural, Advertising &amp; Still Life Photography</h2>
    </div>
  </footer>
);
